import Blue from '~/core';

new Blue({
  name: 'PartDetail',
  selector: '.part-detail-page',
  setup() {
    // SKU selector change handler
    const skuSelector = document.querySelector('#SkuCurrent');
    if (skuSelector) {
      this.$addEvents(skuSelector, 'change', function () {
        window.location = '/' + this.value;
      });
    }

    // Smooth scroll to compatibility section
    const checkCompatibilityBtns = document.querySelectorAll('.check-compatibility-btn');
    checkCompatibilityBtns.forEach((btn) => {
      this.$addEvents(btn, 'click', function () {
        const compatibilitySection = document.querySelector('#compatibility-section');
        if (compatibilitySection) {
          compatibilitySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  },
});

